<mat-chip-list multiple>
    <mat-chip *ngFor="let chip of options" [selected]="chip.state" (click)="chip.state=!chip.state;changeSelected(chip.value)" color="accent">
        {{chip.value}}
        <mat-icon
            *ngIf="chip.state"
            svgIcon="hub_close"
        >
        </mat-icon>
    </mat-chip>
</mat-chip-list>
<p *ngIf="clearSelected" class="reset" (click)="clearAll()">{{consts.LABEL_RESET_SELECTION}}</p>
